export function obterListaTipoEntrega() {
  return (
    [
      { label: 'ENTREGA', value: 'ENTREGA' },
      { label: 'RETIRADA NO LOCAL', value: 'RETIRADA' },
    ]
  );
}
